import ButtonTriangleSpinner from "../../ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import CommonButton from "../../../ui/CommonButton/CommonButton.jsx";
import CommonModal from "../CommonModal.jsx";
import { toPlainDecimalString } from "../../../../helpers/commonHelper";
import './ConfirmationModal.scss';
export const ConfirmationModal = ({
  show,
  handleClose,
  data,
  isSubmitted,
  apiErrorMessage
}) => {
  const sideLabel = data?.side === 0 ? 'BUY' : 'SELL';
  const sideClass = data?.side === 0 ? 'is-buy' : 'is-sell';
  const orderType = data?.type === 0 ? 'LIMIT' : 'MARKET';
  const pairLabel = String(data?.pair_key ?? '').toUpperCase();
  const quantityLabel = toPlainDecimalString(data?.quantity);
  const priceLabel = toPlainDecimalString(data?.price);
  return <CommonModal show={show} handleClose={() => handleClose({
    status: false,
    data: null
  })} backdropClassName="transaction_modal_bckdrop" backdrop="static" disableClose={isSubmitted} className="ConfirmationModal"
  // eyebrow="Trading"
  heading="New Order Confirmation">
      <div className="confirmationModal">
        <div className={`confirmationModal__summary ${sideClass}`}>
          <div className="confirmationModal__side">{sideLabel}</div>
          <div className="confirmationModal__details">
            {quantityLabel} {pairLabel} @{priceLabel} {orderType}
          </div>
          {data?.advanceOrderType ? <div className="confirmationModal__meta">{data.advanceOrderType}</div> : null}
        </div>

        <p className="confirmationModal__auth">
          I authorize Oasis Pro Markets to submit this order to my custodian, on my
          behalf, and to instruct my custodian to settle this transaction in
          accordance with the terms of this order when notified by the ATS.
        </p>

        {apiErrorMessage ? <div className="confirmationModal__apiError" role="alert">
            {apiErrorMessage}
          </div> : null}

        <div className="confirmationModal__actions">
          <CommonButton title="Cancel" disabled={isSubmitted} onClick={() => handleClose({
          status: false,
          data: null
        })} className="white-btn" />
          <CommonButton title={isSubmitted ? <span className="LoaderIcon ps-2">
                  <ButtonTriangleSpinner size={20} />
                </span> : 'Confirm'} disabled={isSubmitted || Boolean(apiErrorMessage)} onClick={() => handleClose({
          status: true,
          data
        })} />
        </div>
      </div>
    </CommonModal>;
};